module.exports = __webpack_public_path__ + "static/media/caret-square-left.72df12a8.svg";